module.exports = __webpack_public_path__ + "img/success_icon.9818f218.png";